import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ size = "md", variant = "default" }) {
  // 175% of original sizes (36/50/72)
  const heightMap = { sm: 63, md: 88, lg: 126 };
  const h = heightMap[size] || heightMap.md;

  const src = variant === "light"
    ? "/logo-bn-dark-transparent.png"   // white-text variant (for dark backgrounds)
    : "/logo-bn-light-transparent.png"; // black-text variant (for light backgrounds)

  return (
    <Link to="/" data-testid="brand-logo" className="inline-flex items-center group">
      <img
        src={src}
        alt="Bodh Networks - Not Just News. Awareness."
        style={{ height: `${h}px`, width: "auto" }}
        className="select-none group-hover:scale-[1.02] transition-transform duration-300 object-contain"
        draggable={false}
      />
    </Link>
  );
}
